export default __webpack_public_path__ + "static/media/era-page.ec47f4e0.png";